<template>
    <div class="[ c-attention ]" v-if="hasSlotData()">
        <h3 class="[ c-attention__title ]" v-if="hasSlotData('title')">
            <slot name="title"></slot>
        </h3>
        <div class="[ c-attention__message ]" v-if="hasSlotData('message')">
            <slot name="message"></slot>
        </div>
        <div class="[ c-attention-list ]" v-if="hasSlotData()">
            <slot></slot>
        </div>
        <button @click="markAllDone()" v-if="hasSlotData('dismissAll')" :disabled="allDone" :class="`c-attantion__button-all c-button c-button--outline c-button--grey ${allDone ? 'all-done': ''}`">
            <svgicon name="check" width="1em" height="1em" v-if="allDone"></svgicon>
            <slot v-if="!allDone" name="dismissAll"></slot>
            <slot v-if="allDone" name="dismissAllDone"></slot>
        </button>
    </div>
</template>

<script>
    import _debounce from 'lodash/debounce'
    import Vue from 'vue'
    import AttentionItem from './AttentionItem.vue'

    Vue.component('v-attention-item', AttentionItem);

    export default {
        data() {
            return {
                items: [],
                allDone: false
            }
        },
        mounted() {

            // Check if all items are done on mount
            this.allItemsDone();

            // Bind event when an item changes state
            this.$on('marked', this.allItemsDone);
        },
        methods: {
            markAllDone(){
                this.$children.forEach((item, index) => setTimeout(() => {
                    item._data.notified = true;
                    item.item.IsReportedToCustomer = true;
                }, 50 * index));
                this.updateNotification();
            },
            allItemsDone() {
                this.allDone = this.$children.every(item => item._data.notified === true);
            },
            hasSlotData(name) {
                if (name) {
                    return this.$slots[name];
                }
                return this.$slots.default;
            },
            updateNotification: _debounce(function () {
                this.$store.dispatch('updatePreOrderNotification', {
                    preOrderId: this.$route.params.id,
                    notificationId: ''
                });
            }, 500),
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-attention {
        padding: em($global-spacing-unit);
        background-color: $color-attention;

        &:not(:last-child) {
            margin-bottom: em($global-spacing-unit);
        }

        p {
            margin-top: 0;
        }
    }

    .c-attention__title {
        margin-bottom: em($global-spacing-unit-tiny);
    }

    .c-attention__message {
        margin-bottom: em($global-spacing-unit-small);
    }

    .c-attantion__button-all {
        &:disabled {
            opacity: .2;
        }
    }

    .c-attention-list {
        width: 100%;
        list-style: none;
        background-color: white;
        padding: em($global-spacing-unit-small);
        box-shadow: 0 0 40px 0 rgba($color-base, .06);
        margin-bottom: em($global-spacing-unit-small);
        max-height: 400px;
        overflow-y: auto;

        > * {
            &:not(:last-child) {
                margin-bottom: em($global-spacing-unit-tiny);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/attention/Attention.vue